import React from 'react';

const LegalCaseIcon = () => {
  return (
    <>
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1998_277)">
          <path
            d="M14.0423 22.7923C14.9625 21.8706 16.2415 21.404 17.5306 21.5279L21.5279 17.5306C21.5163 17.3994 21.5104 17.2681 21.5104 17.1354C21.5104 16.2035 21.8108 15.3227 22.3475 14.5833H18.9583C16.5463 14.5833 14.5833 12.6204 14.5833 10.2083V0.035C14.3485 0.0189583 14.1138 0 13.876 0H7.29167C3.27104 0 0 3.27104 0 7.29167V27.7083C0 31.729 3.27104 35 7.29167 35H20.0638L14.0423 28.9785C12.336 27.2738 12.336 24.4971 14.0423 22.7923ZM5.83333 10.2083H8.75C9.555 10.2083 10.2083 10.8617 10.2083 11.6667C10.2083 12.4717 9.555 13.125 8.75 13.125H5.83333C5.02833 13.125 4.375 12.4717 4.375 11.6667C4.375 10.8617 5.02833 10.2083 5.83333 10.2083ZM5.83333 16.0417H16.0417C16.8467 16.0417 17.5 16.695 17.5 17.5C17.5 18.305 16.8467 18.9583 16.0417 18.9583H5.83333C5.02833 18.9583 4.375 18.305 4.375 17.5C4.375 16.695 5.02833 16.0417 5.83333 16.0417ZM8.75 24.7917H5.83333C5.02833 24.7917 4.375 24.1383 4.375 23.3333C4.375 22.5283 5.02833 21.875 5.83333 21.875H8.75C9.555 21.875 10.2083 22.5283 10.2083 23.3333C10.2083 24.1383 9.555 24.7917 8.75 24.7917ZM17.5 10.2083V0.670833C18.8315 1.17542 20.0565 1.95271 21.0948 2.98958L26.1756 8.07333C27.214 9.11021 27.9913 10.3352 28.4958 11.6667H18.9583C18.1533 11.6667 17.5 11.0119 17.5 10.2083ZM34.5727 34.5727C34.0025 35.1429 33.0808 35.1429 32.5106 34.5727L26.74 28.8021L24.4271 31.115L24.729 31.4169C25.2992 31.9871 25.2992 32.9088 24.729 33.479C24.1588 34.0492 23.2371 34.0492 22.6669 33.479L16.1044 26.9165C15.5342 26.3463 15.5342 25.4246 16.1044 24.8544C16.6746 24.2842 17.5963 24.2842 18.1665 24.8544L18.2481 24.936L24.936 18.2481L24.8544 18.1665C24.2842 17.5963 24.2842 16.6746 24.8544 16.1044C25.4246 15.5342 26.3463 15.5342 26.9165 16.1044L33.479 22.6669C34.0492 23.2371 34.0492 24.1588 33.479 24.729C32.9088 25.2992 31.9871 25.2992 31.4169 24.729L31.115 24.4271L28.8021 26.74L34.5727 32.5106C35.1429 33.0808 35.1429 34.0025 34.5727 34.5727Z"
            fill="#9A252D"
          />
        </g>
        <defs>
          <clipPath id="clip0_1998_277">
            <rect width="35" height="35" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default LegalCaseIcon;
